export interface MiniGame {
  slug: string;
  title: string;
  tagline: string;
  description: string;
  cover: string;
  /**
   * itch.io upload id of the playable HTML5 build. The itch.io profile page
   * itself sends X-Frame-Options: SAMEORIGIN and cannot be framed, so each
   * game is embedded through itch.io/embed-upload/<id>, which is the
   * documented embeddable endpoint. If Alex re-uploads a build on itch.io,
   * the id changes and needs updating here.
   */
  embedId: string;
  itchUrl: string;
}

export const ITCH_PROFILE_URL = "https://alexrodriguezgames.itch.io";

export const miniGames: MiniGame[] = [
  {
    slug: "empower-your-mind",
    title: "Empower Your Mind",
    tagline: "IQ Test",
    description:
      "A short, playful reasoning challenge that gets you thinking about how you approach problems, patterns and decisions under pressure.",
    cover:
      "https://img.itch.zone/aW1hZ2UvNDg5ODM5MC8yOTI5OTkyNy5wbmc=/original/WRHinQ.png",
    embedId: "18811322",
    itchUrl: `${ITCH_PROFILE_URL}/empower-your-mind`,
  },
  {
    slug: "inner-worlds",
    title: "Inner Worlds",
    tagline: "A Personality Test",
    description:
      "An interactive personality exploration — answer as honestly as you can and see which traits and tendencies shape the way you show up.",
    cover:
      "https://img.itch.zone/aW1nLzI5MzAwMTQwLnBuZw==/original/9Oke3L.png",
    embedId: "18820808",
    itchUrl: `${ITCH_PROFILE_URL}/inner-worlds`,
  },
  {
    slug: "emotional-explorer",
    title: "Emotional Explorer",
    tagline: "Uncover Your Feelings",
    description:
      "A gentle guided game for naming what you are feeling and noticing where it comes from — a useful warm-up before a counselling session.",
    cover:
      "https://img.itch.zone/aW1nLzI5MzAwODk4LnBuZw==/original/QJDuhH.png",
    embedId: "18821420",
    itchUrl: `${ITCH_PROFILE_URL}/emotional-explorer`,
  },
];
